// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/reportBasedRejection.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-1155: one source for the FCRA report-based-rejection test, client + server.)
// =============================================================================
export const REPORT_BASED_REJECTION_REASONS = ["Failed background check","Failed drug screen"];
export const REPORT_BASED_REJECTION_REGEX = /\b(background\s*check|criminal|conviction|felony|misdemeanor|mvr|driving\s*record|d[uw]i|cdlis|clearinghouse|drug|alcohol|substance|psp|consumer\s*report|failed\s*(the\s*)?(bg|background|screen))\b/i;
export function isReportBasedRejectionReason(reason) {
  const r = String(reason || '').trim();
  if (REPORT_BASED_REJECTION_REASONS.includes(r)) return true;
  return REPORT_BASED_REJECTION_REGEX.test(r);
}
